module.exports = __webpack_public_path__ + "img/banner-1.f5dc00c1.jpg";